import LoadingSwitcher from "../../../general/loading/LoadingSwitcher";
import CartAddress from "../info/CartAddress";

const CartDeliverySelection = ({ checkout, onBack }) => {

    return (
        <LoadingSwitcher loading={checkout.isLocationsLoading()}>
            {checkout.getLocations().map((location, i) =>
                <div key={i}>
                    <p className="cart-h">{location.Name}</p>
                    <CartAddress address={location.C_Location_ID} />
                    <p className="clickable-text"
                       onClick={() => checkout.updateAddress(location, onBack)}
                    >
                        Use this address
                    </p>
                </div>
            )}
            <p className="clickable-text" onClick={() => onBack()}>Back</p>
        </LoadingSwitcher>
    )
}

const CartLocation = ({ checkout, onChange }) => {

    const setLocation = checkout.getLocationAndAddress();
    const deliveryMessage = checkout.getDeliveryViaRule() === 'D' ? "Delivering to " : "Assigned to ";
    const address = setLocation?.C_Location_ID;

    return (
        <div className="cart-sub-section">
            <LoadingSwitcher loading={checkout.isLocationsLoading()}>
                    <div className="cart-info-split">
                        <p className="cart-h">{deliveryMessage}{setLocation?.Name}</p>
                        <p className="clickable-text"
                           onClick={onChange}
                        >
                            Change
                        </p>
                    </div>
                    <CartAddress address={address}/>
            </LoadingSwitcher>
        </div>
    )

}

const CartDeliveryLocation = ({ checkout, selecting, enforceSelection, setSelecting, afterSelect  }) => {



    return (
        <>
            {!selecting && !enforceSelection ?
                <CartLocation
                    checkout={checkout}
                    onChange={() => setSelecting(true)}
                /> :
                <CartDeliverySelection
                    checkout={checkout}
                    onBack={afterSelect}
                />
            }
        </>
    )

}

export default CartDeliveryLocation;
